<template>

  <div class="ui clearing form segment">
    <div
      class="ui blue right floated right labeled icon button"
      style="background-color: #092442"
      v-if="!updateMode && !loading && $auth.user().see_invoices"
      @click="updateMode = true"
    >
      <i class="right arrow icon"></i>
      Edit
    </div>
    <div class="centered-header">
      <h2 class="ui header" style="color: #092442;">
        <i class="percent icon"></i>
        <div class="content">
          Doctor {{ doctorName }} Percentages
        </div>
      </h2>
    </div>
    <br>
    <div v-if="loading" class="ui active centered inline loader">
      <div class="ui text loader">{{ $t('loading') }}...</div>
    </div>
    <div v-else> 
      <h4 class="ui horizontal divider header">
        Reservation Packages
      </h4>
      <div class="ui five column centered grid">
        <div class="column" v-for="(currentPackage, index) in reservationPackages" :key="'package-' + index">
          <table class="ui center aligned celled teal table">
            <thead>
              <tr>
                <th> {{ currentPackage.name }} </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div class="ui fluid transparent input" v-if="updateMode">
                    <input
                      type="number"
                      style="text-align: center"
                      :placeholder="'Percentage'"
                      v-model.number="currentPackage.percentage"
                      :name="'reservationPackage' + index"
                      min="0"
                      max="1"
                    />
                  </div>
                  <div v-else> 
                    {{ currentPackage.percentage }} 
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <br/>
      <h4 class="ui horizontal divider header">
        Medical Machines
      </h4>
      <div class="ui five column centered grid">
        <div class="column" v-for="(medicalMachine, index) in medicalMachines" :key="'medical-machine-' + index">
          <table class="ui center aligned celled teal table">
            <thead>
              <tr>
                <th> {{ medicalMachine.name }} </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div class="ui fluid transparent input" v-if="updateMode">
                    <input
                      type="number"
                      style="text-align: center"
                      :placeholder="'Percentage'"
                      v-model.number="medicalMachine.percentage"
                      :name="'medicalMachine' + index"
                      min="0"
                      max="1"
                    />
                  </div>
                  <div v-else>{{ medicalMachine.percentage }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <br/>
      <h4 class="ui horizontal divider header">
        Item Categories
      </h4>
      <div class="ui five column centered grid">
        <div class="column" v-for="(itemCategory, index) in itemCategories" :key="'item-category-' + index">
          <table class="ui center aligned celled teal table">
            <thead>
              <tr>
                <th> {{ itemCategory.name }} </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div class="ui fluid transparent input" v-if="updateMode">
                    <input
                      type="number"
                      style="text-align: center"
                      :placeholder="'Percentage'"
                      v-model.number="itemCategory.percentage"
                      :name="'itemCategory' + index"
                      min="0"
                      max="1"
                    />
                  </div>
                  <div v-else>{{ itemCategory.percentage}}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <br>
    <div v-if="updateMode && !loading" class="ui divider"></div>
    <div
      class="ui blue right floated right labeled icon button"
      style="background-color: #092442"
      v-if="updateMode && !loading"
      @click="save()"
    >
      <i class="right arrow icon"></i>
      Save
    </div>

  </div>  
</template>

<script>
export default {
  data() {
    return {
      medicalMachines: [],
      reservationPackages: [],
      itemCategories: [],
      doctor_percentages: null,
      loading: true,
      updateMode: false,
      doctorName: ''
    }
  },
  mounted () {
    this.getData();
  },
  methods: {
    getData () {
      this.axios.all([this.getDoctor(), this.getMedicalMachinesList(), this.getItemCategoriesList(), this.getReservationPackagesList()]).then(
        this.axios.spread((
          doctorResponse, 
          medicalMachinesResponse, 
          itemCategoriesResponse, 
          resevationPackagesResponse
        ) => {
          this.doctorName = doctorResponse.data.user.name
          this.medicalMachines = window._.map(medicalMachinesResponse.data, medicalMachine => {
            return {
              ...medicalMachine,
              percentage: medicalMachine.medical_machine_doctors_percentages.length ? 
                medicalMachine.medical_machine_doctors_percentages[0].amount : 0.0
            }
          })
          this.itemCategories = window._.map(itemCategoriesResponse.data, itemCategory => {
            return {
              ...itemCategory,
              percentage: itemCategory.doctor_percentage.length ? itemCategory.doctor_percentage[0].amount : 0.0
            }
          })
          const packages = resevationPackagesResponse.data.packages
          const reservationDoctorsPercentages = resevationPackagesResponse.data.meta.reservation_doctors_percentages
          const reservationDoctorsPercentagesByPackageId = 
            reservationDoctorsPercentages.reduce((obj, rdp) => ({...obj, [rdp.package_id]: rdp}), {})
          this.reservationPackages = window._.map(packages, currentPackage => {
            return {
              ...currentPackage,
              percentage: reservationDoctorsPercentagesByPackageId[currentPackage.id] ? 
                reservationDoctorsPercentagesByPackageId[currentPackage.id].amount : 0.0
            }
          })
          this.loading = false
        })
      )
    },
    getMedicalMachinesList () {
      return this.$http.get('/medical_machines/meta', {
        params: {
          doctor_id: this.$route.params.id,
          clinic_id: this.getFromLocalStorage('clinicId')
        }
      })
    },
    getItemCategoriesList () {
      return this.$http.get(`/items/categories/doctors/${this.$route.params.id}/percentages`, {
        params: {
          clinic_id: this.getFromLocalStorage('clinicId')
        }
      })
    },
    getReservationPackagesList () {
      return this.$http.get('/packages/meta', {
        params: {
          doctor_id: this.$route.params.id,
          clinic_id: this.getFromLocalStorage('clinicId')
        }
      })
    },
    getDoctor () {
      return this.$http.get(`/doctors/${this.$route.params.id}/meta`)
    },
    save () {
      this.$http.post(`/doctors/${this.$route.params.id}/percentages`, {
        clinic_id: this.getFromLocalStorage('clinicId'),
        doctor_percentages: {
          medical_machines: this.medicalMachines,
          item_categories: this.itemCategories,
          reservation_packages: this.reservationPackages
        }
      }).then(() => {
        this.loading = true
        this.getData()
        this.updateMode = false
      })
    }
  },
}
</script>

<style scoped>
  .centered-header {
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/doctors/Percentages.vue